<template>
  <div class="produits-container">
    
    <div class="produits">
      
      <h1 class="produits-title">Réactifs Produits</h1>
    
      <!-- Breadcrumb -->
      <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/produits">Produits</a> > <a href="/reactifs">Réactifs Produits</a>
      </div>


      <!-- Tableau Reactif de l'hemostase et l'identificatOin des streptocoques -->
      <h2>Reactif de l'hemostase et l'identificatOin des streptocoques</h2>
      <table class="cartes-gel-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Article</th>
            <th>Conditionnement (CDT)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="carte in reactifs" :key="carte.code">
            <td>{{ carte.code }}</td>
            <td>{{ carte.article }}</td>
            <td>{{ carte.cdt }}</td>
          </tr>
        </tbody>
      </table>

            <!-- Tableau des réactifs 
      <h2>TEST RAPIDE FORTRESS</h2>
      <table class="reactifs-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Article</th>
            <th>Conditionnement (CDT)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="reactif in reactifs" :key="reactif.code">
            <td>{{ reactif.code }}</td>
            <td>{{ reactif.article }}</td>
            <td>{{ reactif.cdt }}</td>
          </tr>
        </tbody>
      </table>
-->

      <!-- Tableau des réactifs d'hémostase
      <h2>Réactif de l'hémostase et l'identification des streptocoques</h2>
      <table class="hemostase-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Article</th>
            <th>Conditionnement (CDT)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="hemostase in hemostases" :key="hemostase.code">
            <td>{{ hemostase.code }}</td>
            <td>{{ hemostase.article }}</td>
            <td>{{ hemostase.cdt }}</td>
          </tr>
        </tbody>
      </table> 
          -->
    </div>

  </div>
</template>

<script>
export default {
  name: 'ReactifsI',
  data() {
    return {
      reactifs: [
        { code: 'CS1087315', article: 'strepto grouping test 6x50 DETECTION', cdt: '6*50' },
        { code: 'K29005558', article: 'SCLAVO APTT-S( TCK + CACL2 )KIT 10X5ML', cdt: '10*5 ML' },
        { code: 'K29005185', article: 'SCLAVO PLASMA CALIBRATEUR', cdt: '1*1 ML' },
        { code: 'K29005301', article: 'SCLAVO NORMAL CONTROL PLASMA', cdt: '1*1 ML' },
        { code: 'K29005302', article: 'SCLAVO CONTROL PLASMA PATHOLOGIQUE', cdt: '1* 1 ML' },
       
      ],
      cartesGel: [
        { code: 'OBGFRG-25', article: 'ADULTE OBG FORWARD AND REVERSE', cdt: '25 CARDS' },
        { code: 'OBGNEOG-25', article: 'OBG NEONATAL GROUPING', cdt: '25 CARDS' },
        { code: 'OBGAHG-25', article: 'OBG AHG GEL', cdt: '25 CARDS' },
        { code: 'OBGRBCAS3-CELL', article: 'OBG CELL SCREEN 1-2-3', cdt: '1-2-3 3*5ML' }
      ],
      hemostases: [
        { code: 'CS1087315', article: 'strepto grouping test 6x50 DETECTION', cdt: 'test 6x50' },
        { code: 'K29005558', article: 'SCLAVO APTT-S KIT 10X5ML', cdt: 'KIT 10X5ML' },
        { code: 'K29005005', article: 'SCLAVO PT-READYQUICK KIT 10X5ML', cdt: 'KIT 10X5ML' },
        { code: 'K29053762', article: 'FIBRONOGEN (LYOPHILIZED) 10X2 ML', cdt: '10X2 ML' }
      ]
    };
  }
};
</script>

<style scoped>
.produits-title {
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/reactif.jpg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77); /* Texte blanc pour un meilleur contraste */
  padding: 200px 300px;
  font-size: 40px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px; /* Bordures légèrement arrondies */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Ombre subtile pour donner de la profondeur */
  max-width: 1000px;
}

.produits-container {
  padding: 0px 0px;
  background-color: #f9f9f9; /* Couleur de fond claire pour l'ensemble de la section */
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* Police professionnelle */
}

.produits {
  max-width: 1200px;
  margin: 0 auto;
  padding: 5px;
  font-size: 16px;
  color: #333; /* Couleur du texte améliorée pour la lisibilité */
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* Ombre subtile autour du contenu */
  border-radius: 10px;
}

.breadcrumb {
  font-size: 10px;
  color: #888;
  margin-top: 10px;
}

.breadcrumb a {
  color: #1c1c1d;
  text-decoration: none;
  transition: color 0.3s ease; /* Effet de transition */
}

.breadcrumb a:hover {
  color: #0056b3; /* Couleur au survol */
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* Ombre autour des tableaux */
}

th, td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f5f5f5;
  color: #444;
  font-weight: bold;
  text-transform: uppercase; /* Majuscules pour les en-têtes */
}

td {
  color: #555;
}

th, td {
  border-right: 1px solid #ddd;
}

th:last-child, td:last-child {
  border-right: none;
}

h2 {
  color: #05305b; /* Utilisation d'une couleur professionnelle pour les titres */
  font-size: 24px;
  margin-top: 40px;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 10px;
  text-align: center;
}

/* Responsive Styles */
@media only screen and (max-width: 1040px) {
  .produits-title {
    padding: 100px 50px; /* Réduction du padding pour petits écrans */
    font-size: 24px; /* Taille du texte réduite */
    max-width: 90%; /* Largeur ajustée */
    margin: 0 auto;
  }

  .produits-container {
    padding: 0px 0px; /* Réduction des marges */
  }

  .produits {
    padding: 10px; /* Réduction du padding */
    font-size: 14px; /* Taille du texte réduite */
  }

  table {
    font-size: 14px; /* Réduction de la taille des cellules */
  }

  h2 {
    font-size: 20px; /* Réduction de la taille des titres */
    margin-top: 30px;
  }
}

@media only screen and (max-width: 450px) {
  .produits-title {
    padding: 50px 0px; /* Ajustement pour les très petits écrans */
    font-size: 18px; /* Taille du texte plus petite */
    max-width: 100%;
    margin-top: 10px ;
  }

  .produits-container {
    padding: 0px 0px; /* Réduction des marges */
  }

  .produits {
    padding: 5px;
    font-size: 12px; /* Taille du texte encore réduite */
  }

  table {
    font-size: 12px; /* Taille des cellules ajustée pour mobile */
  }

  th, td {
    padding: 10px; /* Moins d'espace dans les cellules */
  }

  h2 {
    font-size: 18px; /* Taille des titres plus petite */
    margin-top: 20px;
  }

  /* Supprime les ombres sur les très petits écrans pour un affichage plus léger */
  .produits, .produits-title, table {
    box-shadow: none;
  }
}

</style>
